import { ServiceData } from '@/types';

import articles from './FITNESS_ARTICLES_RS.json';
import exercises from './FITNESS_EXERCISES_RS.json';
import recipes from './FITNESS_RECIPES_RS.json';

export const FITNESS_DATA_RS: ServiceData = {
  articles,
  exercises,
  recipes,
};
